import { PropsWithChildren } from 'react'

import { MdWarning } from 'react-icons/md'
import styled, { css } from 'styled-components'

interface IBackgroundColor {
  backgroundColor: string
}

export const NoContentContainer = styled.div.attrs<
  PropsWithChildren<IBackgroundColor>
>(({ theme }) => ({}))<IBackgroundColor>`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 250px;
  padding: 10px;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24);

  ${({ backgroundColor }) => css`
    background-color: ${backgroundColor};
  `}
`

export const Message = styled.span`
  font-size: 16px;
  color: ${({ theme }) => theme.colors.text};
`

export const Icon = styled(MdWarning)`
  color: ${({ theme }) => theme.colors.text};
`
Icon.defaultProps = {
  size: 150,
}
